import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { isAuthenticated, getUser, fetchAuthMe, clearAuth } from "../auth";
import { getCsrfToken } from "../csrf";
import {
  buildAccessMapFromServices,
  hasAccess,
} from "../utils/roleAccess";

const ProtectedRoute = ({ children, page }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated() && !getCsrfToken()) {
      fetchAuthMe().catch(() => {
        clearAuth();
        navigate("/login", { replace: true });
      });
    }
  }, [navigate]);

  // 1️⃣ Authentication check
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const user = getUser();

  // 2️⃣ Safety check
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 3️⃣ Build access map from backend services
  const accessMap = buildAccessMapFromServices(user.services || []);

  // =====================================================
  // 4️⃣ DASHBOARD RULES (MUST BE FIRST)
  // =====================================================
 if (page === "dashboard") {
  // Customer → redirect ONLY if not already on customer dashboard
  if (
    user.userType === "customer" &&
    window.location.pathname !== "/customer/dashboard"
  ) {
    return <Navigate to="/customer/dashboard" replace />;
  }

  return children;
}


  // =====================================================
  // 5️⃣ CUSTOMER ROUTES (NON-DASHBOARD)
  // =====================================================
  if (user.userType === "customer") {
    return children;
  }

  // =====================================================
  // 6️⃣ PLATFORM USERS — PERMISSION CHECK
  // =====================================================
  const allowed = hasAccess(accessMap, page, "V");

  if (!allowed) {
    return <Navigate to="/dashboard" replace />;
  }

  // =====================================================
  // 7️⃣ AUTHORIZED
  // =====================================================
  return children;
};

export default ProtectedRoute;
